import React from 'react';

const SRC = { win: '/oath/win.png', power: '/oath/win.png', person: '/oath/person.png', blessing: '/oath/blessing.png', asset: '/oath/blessing.png' };

/* Crystal jewel icon for gratitude kinds. */
export const CrystalIcon = ({ kind, size = 40, glow = false }) => (
  <img src={SRC[kind] || SRC.win} alt="" width={size} height={size} draggable={false} data-testid={`crystal-icon-${kind}`}
    style={{ width: size, height: size, objectFit: 'contain', filter: glow ? 'drop-shadow(0 0 10px rgba(255,233,160,0.55))' : 'none' }} />
);

export default CrystalIcon;
